function dateFormatJobs(value = '') {
	return moment(value).format('MM월 DD일 H:mm');
}

export default dateFormatJobs;
